'use client';

/**
 * ConfigDisplay
 *
 * JSON viewer component for displaying configuration objects.
 * Shows a formatted, syntax-highlighted view of the config.
 */

import { Card, Stack } from '@cortex/ui';

interface ConfigDisplayProps {
  config: Record<string, unknown>;
  className?: string;
}

export function ConfigDisplay({ config, className }: ConfigDisplayProps) {
  // Format JSON with nice indentation
  const formattedJson = JSON.stringify(config, null, 2);

  return (
    <Card className={`overflow-hidden ${className || ''}`}>
      <Stack className="overflow-x-auto p-4">
        <pre className="text-foreground/70 font-mono text-sm">
          <code>{formattedJson}</code>
        </pre>
      </Stack>
    </Card>
  );
}
